import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Footer from "../../assets/images/Footer.png";
import useHttp from "../../hooks/use-http";
import MiniNavigation from "../MiniNavigation";

const HowToPay = () => {
  const [btnSelected, setBtnSelected] = useState("one");
  const [transactionInfo, setTransactionInfo] = useState({});
  const { sendRequest: fetchTransactionDetails } = useHttp();
  const navigate = useNavigate();

  const { id } = useParams();

  const handleRadioClick = (event) => {
    const radioButtonId = event.target.id;
    setBtnSelected(radioButtonId);
  };

  const handleButtonClick = () => {
    if (btnSelected === "one") {
      setBtnSelected("two");
    } else {
      // Redirect to another route when "Back to Payment" is clicked
      navigate(`/${id}`);
    }
  };

  const getTransactionInfo = (data) => {
    setTransactionInfo(data);
  };

  const fetchTransactionInfo = useCallback(async () => {
    fetchTransactionDetails(
      {
        url: `${process.env.REACT_APP_BASE_URL}/api/sandbox/checkout/${id}`,
        headers: {
          "ngrok-skip-browser-warning": "true",
          "Content-Type": "application/json",
        },
      },
      getTransactionInfo
    );
  }, [fetchTransactionDetails, id]);

  useEffect(() => {
    const fetchData = async () => {
      await fetchTransactionInfo();
    };

    fetchData();
  }, [fetchTransactionInfo]);

  return (
    <div className="flex flex-col items-center justify-center lg:mr-[200px] mx-auto font-LT">
      <MiniNavigation />
      <div className="md:w-[562px] w-[300px] mt-28 xl:ml-7">
        <div className="flex justify-between">
          <p className="text-primary lg:text-xl text-lg font-bold">
            {transactionInfo?.data?.merchantName}
          </p>
          <div>
            <p className="lg:text-2xl text-xl text-primary font-bold">
              <span className="text-xl">{transactionInfo?.data?.currency}</span>{" "}
              {transactionInfo?.data?.amount}
            </p>
            <p className="text-sm text-primary font-normal">
              (Fee NGN {transactionInfo?.data?.fee})
            </p>
            <p className="text-[17.75px] text-normalText font-normal">
              {transactionInfo?.data?.customerEmail || transactionInfo?.data?.email}
            </p>
          </div>
        </div>
        <div className="flex justify-center mt-6">
          <p className="text-[18.75px] font-bold text-darkGrey">
            How to Pay with Phone Number
          </p>
        </div>
        {btnSelected === "one" ? (
          <>
            <div className="flex justify-center md:w-[533.54px] mt-6">
              <p className="text-[18.75px] font-normal text-darkGrey w-[419px]">
                To pay with Phone number, you need to do one of the following:
              </p>
            </div>
            <div className="flex flex-col items-center ">
              <ul className="md:w-[419px] px-4 ml-5 mt-4 list-disc">
                <li className="text-[18.75px] font-normal text-darkGrey">
                  Register Your phone number with Payattitude via *569# USSD
                  code or the mobile App.
                </li>
                <li className="text-[18.75px] font-normal text-darkGrey">
                  Subscribe to the USSD service of Payattitude
                  <span>
                    <Link
                      to={`/${id}/phone-supported-banks/${id}`}
                      className="text-primary font-bold"
                    >
                      {" "}
                      supported bank.
                    </Link>
                  </span>
                </li>
              </ul>
            </div>
          </>
        ) : (
          <>
            <div className="flex justify-center md:w-[533.54px] mt-6">
              <p className="text-[18.75px] font-normal text-darkGrey w-[419px]">
                Once you have registered as a Payattitude subscriber or have
                subscribed to the USSD service of a Payattitude supported bank:
              </p>
            </div>
            <div className="flex flex-col items-center ">
              <ul className="md:w-[419px] px-4 ml-5 mt-4 list-disc">
                <li className="text-[18.75px] font-normal text-darkGrey">
                  Enter your phone number linked to the account you want to use
                  for payment.
                </li>
                <li className="text-[18.75px] font-normal text-darkGrey">
                  You will receive a prompt on the phone number provided to
                  enter your PIN on the phone to securely approve.
                </li>
                <li className="text-[18.75px] font-normal text-darkGrey">
                  Enter the PIN for your bank USSD or the PIN for your
                  Payattitude, if you are a Payattitude subscriber to approve
                </li>
              </ul>
            </div>
          </>
        )}
        <div className="flex justify-center gap-1 mt-6">
          <label className="contain">
            <input
              type="radio"
              id="one"
              name="how-to-pay"
              onChange={handleRadioClick}
              checked={btnSelected === "one"}
            />
            <span className="checkmark"></span>
          </label>
          <label className="contain">
            <input
              type="radio"
              id="two"
              name="how-to-pay"
              onChange={handleRadioClick}
              checked={btnSelected === "two"}
            />
            <span className="checkmark"></span>
          </label>
        </div>
        <div className="flex justify-center mt-6">
          <button
            className=" text-white text-[14.75px] font-medium w-[307px] rounded-[10px] bg-primary py-[20.19px] mb-2"
            onClick={handleButtonClick}
          >
            {btnSelected === "one" ? "Next" : "Back to Payment"}
          </button>
        </div>
        {!localStorage.getItem("AppName") && (
          <div className="flex justify-center mt-6 mb-2">
            <img src={Footer} alt="footerLogo" className="w-[227px]" />
          </div>
        )}
        <style>{`
       /* The container */
.contain {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.contain input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #fff;
  border-radius: 50%;
  border-style:solid;
  border-width:1px;
  border-color:var(--primary);
}

/* On mouse-over, add a grey background color */
.contain:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the radio button is checked, add a orange background */
.contain input:checked ~ .checkmark {
  background-color: var(--primary);
}


      `}</style>
      </div>
    </div>
  );
};

export default HowToPay;
